<template>
  <div class="m-the-header-sub-menu">
    <ul class="m-the-header-sub-menu-list">
      <!--
      <li>
        <a
          class="text-color-university-primary a-tooltip-primary a-tooltip-bottom"
          :data-tooltip-text="$t('mTheHeaderSubMenu.tooltipUniversity')"
          href="#"
          @click.prevent=""
        >
          <i class="fas fa-book"></i>
        </a>
      </li>
      <li>
        <a
          class="a-tooltip-primary a-tooltip-bottom"
          :data-tooltip-text="$t('mTheHeaderSubMenu.tooltipComments')"
          href="#"
          @click.prevent=""
        >
          <i class="fas fa-comment"></i>
        </a>
      </li>
      -->
      <li class="support-button">
        <a
          class="a-tooltip-primary a-tooltip-bottom zen-desk"
          data-tooltip-text="Soporte"
          href="#"
          @click.prevent="openModal"
        >
          <img width="28" height="28" src="@/assets/img/play-ayuda.png">
        </a>
      </li>
      <li v-if="false">
        <a
          class="a-tooltip-primary a-tooltip-bottom"
          :data-tooltip-text="$t('mTheHeaderSubMenu.tooltipNotifications')"
          href="#"
          @click.prevent=""
        >
          <i class="fas fa-bell text-color-notifications-primary"></i>
        </a>
      </li>
      <li>
        <div class="m-dropdown-primary">
          <AtomAvatarPrimary
            :avatar-primary="avatarPrimary"
            @switchDropDown="$dropDown.switchDropDown"
          />
          <MoleculeTheHeaderSubMenuDropDownAcademies
            :academias-usuario="academiasUsuario"
            :usuario="usuario"
          />
          <MoleculeTheHeaderSubMenuDropDownUser
            :academias-usuario="academiasUsuario"
            :usuario="usuario"
          />
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import configApp from '@/config'

export default {
  name: 'MoleculeTheHeaderSubmenu',

  components: {
    MoleculeTheHeaderSubMenuDropDownAcademies: () => import('@/components/molecules/MoleculeTheHeaderSubMenuDropDownAcademies'),
    MoleculeTheHeaderSubMenuDropDownUser: () => import('@/components/molecules/MoleculeTheHeaderSubMenuDropDownUser')
  },

  data () {
    return {
      academiasUsuario: [],

      avatarPrimary: {
        component: 'MoleculeTheHeaderSubMenuDropDownUser',
        image: '',
        method: 'switchDropDown'
      },

      showLoadingState: false
    }
  },

  computed: {
    usuario () {
      return this.$store.getters.getUserData
    }
  },

  watch: {
    usuario: {
      deep: true,

      handler () {
        this.avatarPrimary.image = this.usuario.vidroop_data
          ? this.usuario.vidroop_data.avatar
          : this.usuario.picture
            ? this.usuario.picture
            : ''
      },

      immediate: true
    }
  },

  created () {
    this.readAcademias()

    this.$zendesk.zE('webWidget', 'hide')

    this.$zendesk.zE('webWidget:on', 'close', () => {
      this.$zendesk.zE('webWidget', 'hide')
    })

    this.$zendesk.zE('webWidget:on', 'open', () => {
      this.$zendesk.zE('webWidget', 'show')
    })

    this.$zendesk.zE('webWidget:on', 'userEvent', (event) => {
      if (event.action === 'Web Widget Minimised') {
        this.$zendesk.zE('webWidget', 'close')
      }
    })
  },

  methods: {
    readAcademias () {
      this.$services.read('academia', 'readAcademias', {}, [], this.$auth.filter)
        .then(response => {
          let academias = response.data
          academias.forEach(academia => {
            if (academia.estado && (academia.licencia || academia.id === configApp.vidroopAcademyId)) {
              this.academiasUsuario.push(academia)
            }
          })
          this.showLoadingState = false
        })
        .catch(error => {
          console.log(error)
        })
    },

    openModal () {
      this.$modal.showModal('MoleculeSupportModal')
    }
  }
}
</script>
